import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormFieldNames } from '../../../validations/assignRfidCardValidationSchema';
import RadioGroup from '../../HookFormFields/RadioGroup';
import messages from '../messages';


function RadioGroupCardType() {
  const { formatMessage } = useIntl();

  return (
    <RadioGroup name={FormFieldNames.CardType}>
      <FormControlLabel
        control={<Radio />}
        value={FormFieldNames.DormakabaCard}
        label={formatMessage(messages.userRfidModalCardDormakabaLabel)}
      />
      <Typography variant="caption" color="text.secondary" pl={4}>
        <FormattedMessage {...messages.userRfidModalCardDormakabaHelper} />
      </Typography>
      <FormControlLabel
        control={<Radio />}
        value={FormFieldNames.StandardCard}
        label={formatMessage(messages.userRfidModalCardNormalLabel)}
      />
      <Typography variant="caption" color="text.secondary" pl={4} pb={0}>
        <FormattedMessage {...messages.userRfidModalCardNormalHelper} />
      </Typography>
    </RadioGroup>
  );
}

export default RadioGroupCardType;
